// project imports
import getColors from 'utils/getColors';

// ==============================|| CHIP - COLORS ||============================== //

function getColor({ color, theme }) {
  const colors = getColors(theme, color);
  const { dark } = colors;

  return {
    '&.Mui-focusVisible': {
      outline: `2px solid ${dark}`,
      outlineOffset: 2
    }
  };
}

function getColorStyle({ color, theme }) {
  const colors = getColors(theme, color);
  const { light, lighter, main, darker } = colors;

  return {
    color: main,
    backgroundColor: lighter,
    borderColor: light,
    ...theme.applyStyles('dark', { color: darker }),
    '& .MuiChip-deleteIcon': {
      color: main,
      '&:hover': {
        color: light
      }
    }
  };
}

// ==============================|| OVERRIDES - CHIP ||============================== //

export default function Chip(theme) {
  const defaultLightChip = getColorStyle({ color: 'secondary', theme });
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&:active': {
            boxShadow: 'none'
          },
          '&.MuiChip-colorPrimary': getColor({ color: 'primary', theme }),
          '&.MuiChip-colorSecondary': getColor({ color: 'secondary', theme }),
          '&.MuiChip-colorError': getColor({ color: 'error', theme }),
          '&.MuiChip-colorInfo': getColor({ color: 'info', theme }),
          '&.MuiChip-colorSuccess': getColor({ color: 'success', theme }),
          '&.MuiChip-colorWarning': getColor({ color: 'warning', theme })
        },
        sizeLarge: {
          fontSize: '1rem',
          height: 40
        },
        light: {
          ...defaultLightChip,
          // MUI v9 no longer emits a combined `MuiChip-lightSuccess` class; the color
          // now lives on a separate `MuiChip-color*` class. Scoped to the `light` slot,
          // so these only affect light-variant chips. Old selectors kept for safety.
          '&.MuiChip-lightPrimary, &.MuiChip-colorPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiChip-lightSecondary, &.MuiChip-colorSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiChip-lightError, &.MuiChip-colorError': getColorStyle({ color: 'error', theme }),
          '&.MuiChip-lightInfo, &.MuiChip-colorInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiChip-lightSuccess, &.MuiChip-colorSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiChip-lightWarning, &.MuiChip-colorWarning': getColorStyle({ color: 'warning', theme })
        },
        combined: {
          border: '1px solid',
          ...defaultLightChip,
          '&.MuiChip-combinedPrimary, &.MuiChip-colorPrimary': getColorStyle({ color: 'primary', theme }),
          '&.MuiChip-combinedSecondary, &.MuiChip-colorSecondary': getColorStyle({ color: 'secondary', theme }),
          '&.MuiChip-combinedError, &.MuiChip-colorError': getColorStyle({ color: 'error', theme }),
          '&.MuiChip-combinedInfo, &.MuiChip-colorInfo': getColorStyle({ color: 'info', theme }),
          '&.MuiChip-combinedSuccess, &.MuiChip-colorSuccess': getColorStyle({ color: 'success', theme }),
          '&.MuiChip-combinedWarning, &.MuiChip-colorWarning': getColorStyle({ color: 'warning', theme })
        }
      }
    }
  };
}
